import { render, staticRenderFns } from "./disease_number.vue?vue&type=template&id=c02f92de&scoped=true"
import script from "./disease_number.vue?vue&type=script&lang=js"
export * from "./disease_number.vue?vue&type=script&lang=js"
import style0 from "./disease_number.vue?vue&type=style&index=0&id=c02f92de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02f92de",
  null
  
)

export default component.exports